import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-trash',
    templateUrl: './trash.component.svg',
    styleUrls: ['./trash.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrashComponent {}
